import React from 'react';
import TradingViewWidget from './TradingViewWidget';

// Простой wrapper для совместимости
const TradingViewChart = ({ asset = 'EURUSD', onPriceUpdate }) => {
  return <TradingViewWidget asset={asset} onPriceUpdate={onPriceUpdate} />;
};

export default TradingViewChart;